import React from "react";

import { ModalProps } from "./types";

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  className = "",
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-70 flex items-start justify-center pt-20  font-satoshi dark:text-white bg-gray-500 bg-opacity-60 dark:bg-black dark:bg-opacity-65">
      <div
        className={`relative bg-white dark:bg-black dark:text-white p-6 rounded-lg shadow-xl overflow-y-auto max-h-[calc(100vh-10rem)] ${className}`}
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 dark:text-white"
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
